"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const meNotificationQuery = (0, graphql_tag_1.default)`
  query me_notifications($first: Int!, $before: Int, $after: Int, $last: Int, $search: String) {
    me {
      notifications {
        unreadCount
        list(first: $first, before: $before, after: $after, last: $last, search: $search) {
          edges {
            node {
              id
              date
              type
              title
              link
              isNew
              isPinned
            }
            cursor
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  }
`;
exports.default = meNotificationQuery;